import Icon from '../components/Icon.vue'

Icon.register({
  'layer-group': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M12.4 148L245.3 253.7C252.2 256.8 259.8 256.8 266.6 253.7L499.6 148C516.1 140.5 516.1 115.5 499.6 108L266.6 2.3A25.6-25.6 0 0 1 245.4 2.3L12.4 108C-4.1 115.5-4.1 140.5 12.4 148zM499.6 236.3L441.5 210 279.9 283.2C272.3 286.7 264.3 288.4 256 288.4S239.7 286.7 232.1 283.2L70.5 210 12.4 236.3C-4.1 243.8-4.1 268.8 12.4 276.3L245.3 381.9C252.2 385 259.8 385 266.6 381.9L499.6 276.3C516.1 268.8 516.1 243.8 499.6 236.3zM499.6 364.1L441.7 337.9 279.9 411.2C272.3 414.7 264.3 416.4 256 416.4S239.7 414.7 232.1 411.2L70.3 337.9 12.4 364.1C-4.1 371.6-4.1 396.6 12.4 404.1L245.3 509.7C252.2 512.8 259.8 512.8 266.6 509.7L499.6 404.1C516.1 396.6 516.1 371.6 499.6 364.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/layer-group.js
// module id = YjPK
// module chunks = 144